import styled from "styled-components";
import {OptInWinHighlightDefaultBox} from "./opt-in-win-highlight.default.box";

export const OptInWinHighlightCasion777Box = styled(OptInWinHighlightDefaultBox)`
    width: 140px;
    box-shadow: 
        0px 0px 5px 0px #30F7E8 inset,
        0px 0px 15px 0px #FFE60166 inset,
        0px 0px 20px 0px #30F7E833;

    background-color: #361018; 
    background-image: radial-gradient( #FFFFFF -65%, #361018 50%);

    border: 1px solid #30F7E8;
    margin: 4px 6px;
`;
